module.exports = __webpack_public_path__ + "assets/events_political_terrorism_primary.d1207247.svg";